import { FaUser, FaUsers } from "react-icons/fa";
import { AiFillHome, AiOutlineMail, AiOutlinePlusCircle } from "react-icons/ai";
import { BiCog } from "react-icons/bi";
import { HiAcademicCap } from "react-icons/hi";
import { BsViewStacked } from "react-icons/bs";
import { FormattedMessage } from "react-intl";
import { GiHealthNormal } from "react-icons/gi";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { AiOutlineFileSearch } from "react-icons/ai";
import { CiDeliveryTruck } from "react-icons/ci";
import { AiOutlineRobot, AiOutlineDatabase } from "react-icons/ai";
import { TbDental } from "react-icons/tb";

export const normalLinks = [
    {
        title: <FormattedMessage id="dshbrd" defaultMessage={"Dashboard"} />,
        icon: AiFillHome,
        to: "/"
    },
    {
        title: <FormattedMessage id="deliveries" defaultMessage={"All Deliveries"} />,
        icon: CiDeliveryTruck,
        to: "/deliveries"
    },
    {
        title: <FormattedMessage id="usrs" defaultMessage={"Users"} />,
        icon: FaUsers,
        to: "/users",
        user_noti: true
    },
    {
        title: <FormattedMessage id="ai_indexes" defaultMessage={"AI Indexes"} />,
        icon: AiOutlineRobot,
        to: "/ai",
    },
    // {
    //     title: <FormattedMessage id="dataset_builder" defaultMessage={"Dataset Builder"} />,
    //     icon: AiOutlineDatabase,
    //     to: "/dataset-builder",
    // },
    {
        title: <FormattedMessage id="all_cses" defaultMessage={"All Cases"} />,
        icon: GiHealthNormal,
        to: "/cases",
    },
    {
        title: <FormattedMessage id="case_studies" defaultMessage={"Case Studies"}/>,
        icon: GiHealthNormal,
        to: "/case-studies",
    },
    // {
    //     title: <FormattedMessage id="ceph_analysis" defaultMessage={"Ceph Analysis"} />,
    //     icon: TbDental,
    //     to: "/ceph-analysis",
    // },
    {
        title: <FormattedMessage id="invoices" defaultMessage={"Invoices"} />,
        icon: FaFileInvoiceDollar,
        links: [
            {
                title: <FormattedMessage id="All invoices" defaultMessage={"All Invoices"} />,
                icon: AiOutlineFileSearch,
                to: "/invoices"
            },
            {
                title: <FormattedMessage id="add_invoices" defaultMessage={"Add Invoices"} />,
                icon: AiOutlinePlusCircle,
                to: "/invoices/add"
            },
        ]
    },

    {
        title: <FormattedMessage id="c.frms" defaultMessage={"Contact Forms"} />,
        icon: AiOutlineMail,
        to: "/contact-forms"
    },
    {
        title: <FormattedMessage id="crses" defaultMessage={"Courses"} />,
        icon: HiAcademicCap,
        to: "/courses",
    },
    {
        title: <FormattedMessage id="support" defaultMessage={"Support"} />,
        icon: AiOutlineMail,
        to: "/support",
        support_noti: true
    },
    {
        title: <FormattedMessage id="m.p" defaultMessage={"My Profile"} />,
        icon: FaUser,
        to: "/profile"
    },
]